import { useTranslation } from 'next-i18next';

export const useServerTranslation = (file = 'common') => {
    const { t, ...rest } = useTranslation(file);
    const translateEnumValue = (
        translation: string,
        value: string,
    ) => t(`${translation}${value.replaceAll('_', '-')}`);

    return { t, ...rest, translateEnumValue };
};
